import * as Yup from "yup";
import { transformSnakeToCamel, transformModelToJson } from "utils/transform";
import { ContentSchema as ContentBaseSchema } from "model/_base";

// Yup Schemas
export const DataSchema = ContentBaseSchema.clone()
  .transform(transformSnakeToCamel)
  .shape({
    contentImg: Yup.mixed()
      .required("กรุณาอัปโหลดรูปภาพ")
      .test("fileRequired", "กรุณาอัปโหลดรูปภาพ", (value) => {
        return value !== null && value !== undefined && value !== '';
      }),
    contentDetail: Yup.string().nullable(),
  });

export class ContentModel {
  /**
   * Transform json to model
   * @param {object} json - JSON data to transform
   * @returns {object} Transformed model
   */
  static jsonToModel(json) {
    try {
      const model = DataSchema.cast(json, {
        abortEarly: false,
        stripUnknown: true,
      });
      return model;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Transform model to json
   * @param {object} model - Model to transform
   * @returns {object} Transformed JSON
   */
  static modelToJson(model) {
    return transformModelToJson(model);
  }
}
